<template>
    <JourneyRenderer></JourneyRenderer>
</template>

<script>
  import JourneyRenderer from "../../components/journey/JourneyRenderer";
  export default {
    name: "Journey",
    components:{
      JourneyRenderer
    },
    methods:{
      next(){

      },
    }
  }
</script>

<style scoped>

</style>